import { Badge, Typography } from "@mui/material";

import { appVersion } from "@/helpers/common";
import { Link } from "react-router-dom";
import logo from "../assets/logo-icon-white.svg";
import styles from "../styles/components/app-logo.module.scss";
import { Img } from "./image";

export const LogoImage = () => {
  return (
    <Badge 
      className={styles.badge}
      badgeContent={`v${appVersion}`}
      color="info" 
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <Link
        to="/dashboard"
      >
        <Img src={logo} alt='MetOceanAtlas logo' />
      </Link>
    </Badge>
  )
}

export const AppLogo = () => {
  return (
    <Typography
      component="h1"
      variant="h6"
      color="inherit"
      noWrap
      sx={{ flexGrow: 1 }}
      className={styles.header}
    >
      <LogoImage />
    </Typography>
  
  )
}